import {css} from 'lit';

import {defaultStyles} from '../../../components/image.js';

export const styles = defaultStyles.extends({
  statics: css``,
  radiusGen: () => '',
  shadowGen: () => '',
});

export default {styles};
